import * as React from "react"

const SvgArchive = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 22.857q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 20.857V9.582q-.45-.274-.725-.712A1.86 1.86 0 0 1 2 7.857v-3q0-.824.587-1.412A1.93 1.93 0 0 1 4 2.857h16q.824 0 1.413.588.587.587.587 1.412v3q0 .575-.275 1.013a2.2 2.2 0 0 1-.725.712v11.275a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-13v11h14v-11zm-1-2h16v-3H4zm6 7h4q.424 0 .713-.287a.97.97 0 0 0 .287-.713.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288h-4a.97.97 0 0 0-.713.288.97.97 0 0 0-.287.712.97.97 0 0 0 .287.713q.288.287.713.287" />
  </svg>
)
export default SvgArchive
